<template>
  <div id="open-ended-form" class="pb-3" v-if="question && question.is_enabled">
    <div v-if="content && content.visible">
      <!-- LONG ANSWER START -->
      <template
        v-if="parseInt(content.attributes.char_length) >= inputTextLimit"
      >
        <b-form-group label-for="input-long-answer">
          <template slot="label">
            <span class="question-title">{{ question.question }}</span>
            <sup class="text-danger font-weight-bold" v-if="content.required">
              *
            </sup>
          </template>
          <div>
              <ImageRender
                v-if="question.image"
                :imgBase64="question.image" :showCloseButton="false"/>
          </div>
          <b-form-textarea
            id="input-long-answer"
            rows="4"
            :placeholder="content.attributes.placeholder"
            :state="isInvalid('open_ended')"
            @keypress.native="filterAlphaNumericPunctuations"
            v-model="answers[question.question]"
            :value="
              (answers[question.question] = answers[question.question]
                ? answers[question.question]
                : '')
            "
            :maxlength="content.attributes.char_length"
          >
          </b-form-textarea>
          <b-form-invalid-feedback :state="isInvalid(question.question)">
            {{ errorMessage(question.question) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </template>
      <!-- LONG ANSWER END -->
      <!-- SHORT ANSWER START -->
      <template v-else>
        <b-form-group label-for="input-short-answer">
          <template slot="label">
            <span class="question-title"> {{ question.question }} </span>
            <sup class="text-danger font-weight-bold" v-if="content.required">
              *
            </sup>
          </template>
          <b-input
            id="input-short-answer"
            type="text"
            :placeholder="content.attributes.placeholder"
            :state="isInvalid('open_ended')"
            @keypress.native="filterAlphaNumericPunctuations"
            v-model="answers[question.question]"
            :value="
              (answers[question.question] = answers[question.question]
                ? answers[question.question]
                : '')
            "
            :maxlength="content.attributes.char_length"
          >
          </b-input>
          <b-form-invalid-feedback :state="isInvalid(question.question)">
            {{ errorMessage(question.question) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </template>
      <!-- SHORT ANSWER START -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ImageRender from "../../../components/ImageRender.vue";
export default {
  name: "OpenEnded",
  components: {
    ImageRender,
  },
  data() {
    return {
      content: null,
      inputTextLimit: 50
    };
  },
  props: ["question", "answers"],
  computed: {
    ...mapGetters("survey", ["errors"])
  },
  methods: {
    isNotAlphaNumericPunctuations(input) {
      return /[^A-Za-z0-9 ,_.!?'":()\s\-]+/g.test(input); //eslint-disable-line
    },
    filterAlphaNumericPunctuations(e) {
      if (this.isNotAlphaNumericPunctuations(String.fromCharCode(e.keyCode)))
        e.preventDefault();
    },
    isInvalid(field) {
      if (this.errors === null) {
        return null;
      } else {
        return !Object.keys(this.errors).includes(field)
          ? null
          : !Object.keys(this.errors).includes(field);
      }
    },
    errorMessage(field) {
      if (this.errors === null) {
        return "";
      } else if (Object.keys(this.errors).includes(field)) {
        return Array.isArray(this.errors[field])
          ? this.errors[field].join(" ")
          : this.errors[field];
      }
    }
  },
  created() {
    if (this.question.contents.length) this.content = this.question.contents[0];
  }
};
</script>

<style></style>
